const INITIAL_STATE = {
  list: null
};
export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "ALL_NOTIFICATION": {
      return {
        ...state,
        list: action.payload
      };
    }
    case "SOCKET_NOTIFICATION": {
      return {
        ...state,
        list: [...state.list, action.payload]
      };
    }
    default: {
      return state;
    }
  }
}
